import React, { useEffect, useState } from "react";
import "./styles/Navbar.css";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setLogout } from "../Redux/Feature/loginSlice";
import prolegionlogo from "../Assets/ProLegionLogo.svg";
import clientLogo from "../Assets/Home/clientsLogo.png";
import consultantLogo from "../Assets/Home/consultantsLogo.png";
import vendorLogo from "../Assets/Home/vendorsLogo.png";

export default function Navbar() {
  const [menu, setMenu] = useState(false);
  const [solution, setSolution] = useState(true)
  const [support, setSupport] = useState(true)
  const [mobileMenu, setMobileMenu] = useState(false);
  const LoginStatus = useSelector((state) => state.user.value);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [colorChange, setColorchange] = useState(false);
  useEffect(() => {
    setMobileMenu(!mobileMenu);
    setSolution(!solution);
    setSupport(!support)
  }, [])
  const changeNavbarColor = () => {
    if (window.scrollY >= 80) {
      setColorchange(true);
    } else {
      setColorchange(false);
    }
  };
  window.addEventListener("scroll", changeNavbarColor);

  return (
    <div className="bg-white sticky top-0 left-0 z-50">
      <nav
        style={{ backgroundColor: colorChange ? "#EDFDF9" : "white" }}
        className="flex px-4 border-b md:shadow-lg items-center relative"
      >
        <Link to="/">
          <img
            src={prolegionlogo}
            className="h-[4.5rem] w-[100%] p-3 md:max-[800px]:px-1"
            alt="Logo"
          />
        </Link>
        <ul
          style={{
            visibility: menu ? "hidden" : "visible",
            WebkitBackdropFilter: "blur(10px)",
            backdropFilter: "blur(10px)",
            // backgroundColor: "rgba(255, 255, 255, 0.5)",
          }}
          className="md:px-2 md:visible hidden ml-auto md:flex md:space-x-2 absolute md:relative top-full left-0 right-0 md:items-center"
        >
          <li className="relative parent">
            <Link
              to="#"
              className="flex justify-between md:inline-flex p-4 items-center hover:bg-gray-50 space-x-2"
            >
              <span>Our Solutions</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 fill-current pt-1"
                viewBox="0 0 24 24"
              >
                <path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z" />
              </svg>
            </Link>
            <ul
              style={{
                WebkitBackdropFilter: "blur(10px)",
                backdropFilter: "blur(10px)",
                backgroundColor: "rgba(255, 255, 255, 1)",
              }}
              className="child transition duration-300 md:absolute top-full left-0 md:w-96 md:shadow-lg md:rounded-b"
            >
              <li>
                <Link to="/client" className="flex px-4 py-3 hover:bg-gray-50">
                  <img alt="client" src={clientLogo} className="h-10 w-10 mr-3 mt-1" />
                  <div className="flex flex-col tracking-wide">
                    <span className="text-[16px]">Client</span>
                    <span className="text-[#787878] text-[14px] text-justify">
                      Manage your IT vendors and consultants, easy onboarding
                      and retain your IT workforce creating own resource pool.
                    </span>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/vendor" className="flex px-4 py-3 hover:bg-gray-50">
                  <img alt="vendor" src={vendorLogo} className="h-10 w-10 mr-3 mt-1" />
                  <div className="flex flex-col tracking-wide">
                    <span className="text-[16px]">Vendor</span>
                    <span className="text-[#787878] text-[14px] text-justify">
                      Streamline your clients and consultants management
                      process. State of art solution to take your IT consulting
                      practice to next level.
                    </span>
                  </div>
                </Link>
              </li>
              <li>
                <Link
                  to="/consultant"
                  className="flex px-4 py-3 hover:bg-gray-50"
                >
                  <img alt="consultant" src={consultantLogo} className="h-10 w-10 mr-3 mt-1" />
                  <div className="flex flex-col tracking-wide">
                    <span className="text-[16px]">Consultants</span>
                    <span className="text-[#787878] text-[14px] text-justify">
                      Being Independent consultants manage your jobs,
                      timesheets, invoices. Showcase your skills to various
                      clients and explore new jobs opportunities.
                    </span>
                  </div>
                </Link>
              </li>
            </ul>
          </li>
          <li className="relative parent">
            <span className="flex justify-between md:inline-flex p-4 items-center hover:bg-gray-50 space-x-2 cursor-pointer">
              <span>Support</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 fill-current pt-1"
                viewBox="0 0 24 24"
              >
                <path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z" />
              </svg>
            </span>
            <ul
              style={{
                WebkitBackdropFilter: "blur(10px)",
                backdropFilter: "blur(10px)",
                backgroundColor: "rgba(255, 255, 255, 1)",
              }}
              className="child transition duration-300 md:absolute top-full left-0 md:w-28 md:shadow-lg md:rounded-b"
            >
              <li>
                <Link to="/faq" className="flex px-4 py-3 hover:bg-gray-50">
                  <span className="text-[16px]">FAQ</span>
                </Link>
              </li>
              <li>
                <Link to="/contact" className="flex px-4 py-3 hover:bg-gray-50">
                  <span className="text-[16px]">Contact us</span>
                </Link>
              </li>
            </ul>
          </li>
          <li>
            <Link
              to="/aboutus"
              className="flex md:inline-flex p-4 items-center hover:bg-gray-50"
            >
              <span>About</span>
            </Link>
          </li>
          <li>
            <Link
              to="/pricing"
              className="flex md:inline-flex p-4 items-center hover:bg-gray-50"
            >
              <span>Pricing</span>
            </Link>
          </li>
          {/* <li>
            <a
              href="https://prolegion.com/blog/"
              className="flex md:inline-flex p-4 items-center hover:bg-gray-50"
            >
              <span>Blog</span>
            </a>
          </li> */}
          <span className="flex flex-row items-center space-x-4">
            {!LoginStatus ? (
              <>
                <li className="md:ml-0 ml-3 my-6">
                  <Link to="/signin">
                    <button
                      className="text-gray-700 hover:animate-pulse shadow-md shadow-gray-400"
                      style={{
                        width: "120px",
                        height: "45px",
                        border: "2px solid #139588",
                        color: "#139588",
                        borderRadius: "25px",
                      }}
                    >
                      Login
                    </button>
                  </Link>
                </li>
                <li className="md:ml-0 ml-3 my-6">
                  <Link to="/signup">
                    <button
                      style={{
                        width: "120px",
                        height: "45px",
                        background: "#139588",
                        borderRadius: "25px",
                        color: "white",
                      }}
                      className="hover:animate-pulse shadow-md shadow-gray-400"
                    >
                      Register
                    </button>
                  </Link>
                </li>
              </>
            ) : (
              <>
                <li className="md:ml-0 ml-3 my-8">
                  <Link to="/dashboard">
                    <button
                      style={{
                        background: "#139588",
                        borderRadius: "25px",
                        color: "white",
                      }}
                      className="h-[45px] w-[120px] shadow-md shadow-gray-400"
                    >
                      Dashboard
                    </button>
                  </Link>
                </li>
                <li className="md:ml-0 ml-3 my-8">
                  <button
                    onClick={() => {
                      navigate("/");
                      dispatch(setLogout());
                    }}
                    className="text-gray-700 shadow-md shadow-gray-400"
                    style={{
                      width: "120px",
                      height: "45px",
                      border: "2px solid #139588",
                      color: "#139588",
                      borderRadius: "25px",
                    }}
                  >
                    Logout
                  </button>
                </li>
              </>
            )}
          </span>
        </ul>

        {/* mobile */}
        <ul
          style={{
            visibility: mobileMenu ? "hidden" : "visible",
            WebkitBackdropFilter: "blur(10px)",
            backdropFilter: "blur(10px)",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
          }}
          className="md:px-2 overflow-visible md:hidden ml-auto md:flex md:space-x-2 absolute md:relative top-full left-0 right-0 md:items-center"
        >
          <li className="relative parent">
            <Link
              to="#"
              onClick={() => {
                setSolution(!solution)
              }}
              className="flex justify-between md:inline-flex p-4 items-center hover:bg-gray-50 space-x-2"
            >
              <span>Our Solutions</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 fill-current pt-1"
                viewBox="0 0 24 24"
              >
                <path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z" />
              </svg>
            </Link>
            <ul
              style={{
                display: solution ? "block" : "none",
                WebkitBackdropFilter: "blur(10px)",
                backdropFilter: "blur(10px)",
                backgroundColor: "rgba(255, 255, 255, 1)",
              }}
              className="child transition duration-300 md:absolute top-full left-0 md:w-96 md:shadow-lg md:rounded-b"
            >
              <li>
                <Link to="/client" className="flex px-4 py-3 hover:bg-gray-50">
                  <img alt="client" src={clientLogo} className="h-10 w-10 mr-3 mt-1" />
                  <div className="flex flex-col tracking-wide">
                    <span className="text-[16px]">Client</span>
                    <span className="text-[#787878] text-[14px] text-justify">
                      Manage your IT vendors and consultants, easy onboarding
                      and retain your IT workforce creating own resource pool.
                    </span>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/vendor" className="flex px-4 py-3 hover:bg-gray-50">
                  <img alt="vendor" src={vendorLogo} className="h-10 w-10 mr-3 mt-1" />
                  <div className="flex flex-col tracking-wide">
                    <span className="text-[16px]">Vendor</span>
                    <span className="text-[#787878] text-[14px] text-justify">
                      Streamline your clients and consultants management
                      process. State of art solution to take your IT consulting
                      practice to next level.
                    </span>
                  </div>
                </Link>
              </li>
              <li>
                <Link
                  to="/consultant"
                  className="flex px-4 py-3 hover:bg-gray-50"
                >
                  <img alt="consultant" src={consultantLogo} className="h-10 w-10 mr-3 mt-1" />
                  <div className="flex flex-col tracking-wide">
                    <span className="text-[16px]">Consultants</span>
                    <span className="text-[#787878] text-[14px] text-justify">
                      Being Independent consultants manage your jobs,
                      timesheets, invoices. Showcase your skills to various
                      clients and explore new jobs opportunities.
                    </span>
                  </div>
                </Link>
              </li>
            </ul>
          </li>
          <li className="relative parent">
            <span onClick={() => {
              setSupport(!support)
            }} className="flex justify-between md:inline-flex p-4 items-center hover:bg-gray-50 space-x-2 cursor-pointer">
              <span >Support</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 fill-current pt-1"
                viewBox="0 0 24 24"
              >
                <path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z" />
              </svg>
            </span>
            <ul
              style={{
                display: support ? "block" : "none",
                WebkitBackdropFilter: "blur(10px)",
                backdropFilter: "blur(10px)",
                backgroundColor: "rgba(255, 255, 255, 1)",
              }}
              className="child transition duration-300 md:absolute top-full left-0 md:w-28 md:shadow-lg md:rounded-b"
            >
              <li>
                <Link to="/faq" className="flex px-4 py-3 hover:bg-gray-50">
                  <span className="text-[16px]">FAQ</span>
                </Link>
              </li>
              <li>
                <Link to="/contact" className="flex px-4 py-3 hover:bg-gray-50">
                  <span className="text-[16px]">Contact us</span>
                </Link>
              </li>
            </ul>
          </li>
          <li>
            <Link
              to="/aboutus"
              className="flex md:inline-flex p-4 items-center hover:bg-gray-50"
            >
              <span>About</span>
            </Link>
          </li>
          <li>
            <Link
              to="/pricing"
              className="flex md:inline-flex p-4 items-center hover:bg-gray-50"
            >
              <span>Pricing</span>
            </Link>
          </li>
          <span className="flex flex-row items-center space-x-4">
            {!LoginStatus ? (
              <>
                <li className="md:ml-0 ml-3 my-6">
                  <Link to="/signin">
                    <button
                      className="text-gray-700 hover:animate-pulse shadow-md shadow-gray-400"
                      style={{
                        width: "120px",
                        height: "45px",
                        border: "2px solid #139588",
                        color: "#139588",
                        borderRadius: "25px",
                      }}
                    >
                      Login
                    </button>
                  </Link>
                </li>
                <li className="md:ml-0 ml-3 my-6">
                  <Link to="/signup">
                    <button
                      style={{
                        width: "120px",
                        height: "45px",
                        background: "#139588",
                        borderRadius: "25px",
                        color: "white",
                      }}
                      className="hover:animate-pulse shadow-md shadow-gray-400"
                    >
                      Register
                    </button>
                  </Link>
                </li>
              </>
            ) : (
              <>
                <li className="md:ml-0 ml-3 my-8">
                  <Link to="/dashboard">
                    <button
                      style={{
                        background: "#139588",
                        borderRadius: "25px",
                        color: "white",
                      }}
                      className="h-[45px] w-[120px] shadow-md shadow-gray-400"
                    >
                      Dashboard
                    </button>
                  </Link>
                </li>
                <li className="md:ml-0 ml-3 my-8">
                  <button
                    onClick={() => {
                      navigate("/");
                      dispatch(setLogout());
                    }}
                    className="text-gray-700 shadow-md shadow-gray-400"
                    style={{
                      width: "120px",
                      height: "45px",
                      border: "2px solid #139588",
                      color: "#139588",
                      borderRadius: "25px",
                    }}
                  >
                    Logout
                  </button>
                </li>
              </>
            )}
          </span>
        </ul>

        <div
          onClick={() => {
            setMobileMenu(!mobileMenu);
            setSolution(false);
            setSupport(false);
          }}
          className="ml-auto md:hidden text-gray-500 cursor-pointer"
        >
          {!mobileMenu ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5 fill-current"
              viewBox="0 0 24 24"
            >
              <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
          )}
        </div>
      </nav>
    </div>
  );
}
